import React, { Component } from 'react';
import ComboBox from '../combo-box'
import TextField from "material-ui/TextField"
import { withStyles } from 'material-ui/styles';
import Button from 'material-ui/Button';
import Portal from 'material-ui/Portal'
import EmployeeForm from './EmployeeForm';
import Input from 'material-ui/Input';
import IconButton from 'material-ui/IconButton/IconButton';
import Typography from 'material-ui/Typography';

import List, { ListItem, ListItemSecondaryAction, ListItemText } from 'material-ui/List';
import green from 'material-ui/colors/green';

import {ajaxPost} from '../ajax';
import SearchEmployee from './SearchEmployee';
import {clone} from './utils';

var GetBlankEmployee = require('./BlankEmployee');

const styles = theme => ({

      button: {
        '&:hover': {
          backgroundColor: green[700],
        },
      },
      wrapper: {
        margin: theme.spacing.unit,
        position: 'relative',
      },
      
    });


  
class EmployeeModule extends Component {
    onSelectEmployee(emp,searchState)
    {
        this.setState({selectedEmployee:emp});

        //this.setState({searchState:searchState});
    }
  
    state = 
    {
        selectedEmployee:null,
        mode:"search",
        searchState :
        {
            selected:null,
            search:'',
            listEmployees:[],
            page:0,
            totalEmployees:0,
        },
        disableToolbar:false
    }

    onAdd = (searchState) =>
    {
        var newEmp = GetBlankEmployee();

        this.setState({searchState});
        this.setState({selectedEmployee:newEmp})
        this.setState({mode:"add"});
    }

    onUpdateComplete = (emp) =>
    {
        var list = this.state.searchState.listEmployees;
        var searchState = this.state.searchState;
        if( this.state.mode == "add")
        {
            searchState.listEmployees = [emp];
            searchState.selected = emp;
            searchState.totalEmployees = 1;
            searchState.page = 0;
        }
        else
        {
            var ndx = list.indexOf(this.state.selectedEmployee);
            if( ndx >= 0 )
                list[ndx] = emp;
        }
        this.setState({searchState:this.state.searchState});
        this.setState({mode:'search'});
    }

    onCloseForm = () =>
    {
        this.setState({mode:'search'});
    }

    onEdit = (searchState) =>
    {
        this.setState({searchState});
        this.setState({mode:"edit"});
    }

    render()
    {
        var {saving} = this.state;
        var {classes} = this.props;
        return this.state.mode == 'search' ? 
        <SearchEmployee toolbar={this.props.toolbar} 
            onSelectEmployee={this.onSelectEmployee.bind(this)}
            appendToolbar={this.appendToolbar}
            searchState={this.state.searchState}
            onEdit={this.onEdit.bind(this)}
            onAdd={this.onAdd.bind(this)}
        />
        :
        <div>
            <EmployeeForm employee={clone(this.state.selectedEmployee)} 
                toolbar={this.props.toolbar}
                onCloseForm={this.onCloseForm}
                onUpdateComplete={this.onUpdateComplete}
            />
        </div> 
    
        
    }
}

export default withStyles(styles)(EmployeeModule);



// WEBPACK FOOTER //
// ./src/admin/EmployeeModule.js